import { Stores } from "setupContext";


export class ImagesStore {
    public init(rootStore: Stores) {
        // console.log(rootStore);
        return this;
    }
}